export default __webpack_public_path__ + "static/treneri-petr-zabystrzan-d075555da2859f0af710b0a171f3b772.jpg";